import { TimelineMax, TweenLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import { PixelPerfectHitArea } from "html-living-framework/lib/Input";
import { isMobile } from "html-living-framework/lib/Utils/PlatformUtils";
import * as AssetHelpers from "../core/AssetHelpers";
import {HoverableButton, TextureButton} from "../core/Button";
import { Container } from "../core/Container";
import {Callback, Mix} from "../core/Reflection";
import { Sprite } from "../core/Sprite";
import {TransformBackup} from "../core/TransformBackup";
import { LightsOutObjectType } from "../data/LightsOutObjectType";
import {TrashType} from "../data/TrashType";
import { GlowFilter } from "../filters/GlowFilter";
import { OutlineFilter } from "../filters/OutlineFilter";
import { AudioChannel } from "../managers/AudioChannel";
import { Button } from "./Button";

export abstract class LightsOutObject extends Button {
    public hoverSFX?: string;
    public lightsOutSFX?: string;
    public get hoverDisabled() {return !this.clickable; }
    public get downDisabled() {return !this.clickable; }

    public clickable: boolean = true;
    public objectType: LightsOutObjectType;
    public switched?: LightsOutObject;
    public turnedOff: boolean = false;
    protected outlineFilter: OutlineFilter;

    constructor(pData: {type: LightsOutObjectType}) {
        super();
        this.objectType = pData.type;
        // this.clickable = pClickable;
        this.outlineFilter = new OutlineFilter(5, 0xffff00);
        this.outlineFilter.enabled = false;
        this.sprite.filters = [this.outlineFilter];
        this.onDown.add(() => {
            PubSub.publishSync("item clicked", this);
        });

        this.onOver.add(() => {
            if (this.hoverSFX && !this.turnedOff) {
                AudioChannel.SFX.play(this.hoverSFX, "loop");
            }
        });

        this.onOut.add(() => {
            if (this.hoverSFX) {
                AudioChannel.SFX.stop(this.hoverSFX);
            }
        });
    }

    public onLayout() {
        this.scale.set(Math.max(this.scale.x, this.scale.y));

        if (isMobile()) {
            const width = Math.max(
                100 / Math.abs(this.scale.x),
                this.sprite.width + 20,
            );

            const height = Math.max(
                100 / Math.abs(this.scale.y),
                this.sprite.height + 20,
            );

            this.hitArea = new PIXI.RoundedRectangle((this.sprite.anchor.x - 0.5) * -width - (width / 2), (this.sprite.anchor.y - 0.5) * -height - (height /  2), width, height);
        }

        const pulseTimeline = new TimelineMax();
        pulseTimeline.fromTo(this.outlineFilter, 0.5, {thickness: 5}, {thickness: 2});
        pulseTimeline.fromTo(this.outlineFilter, 0.5, {thickness: 2}, {thickness: 5});
        pulseTimeline.yoyo(true);
        pulseTimeline.repeat(-1);
        pulseTimeline.repeatDelay(3);
    }

    public TurnOn(pOptions: {animate: boolean} = {animate: true}): void {
        if (pOptions.animate === true) {
            PubSub.publishSync("item turned on", this);
        }
        // this.enabled = true;
        this.turnedOff = false;

        if (this.objectType === LightsOutObjectType.Light) {
            const glowSprite = this.parent.getChildByName(this.name + "-on-glow", true);
            if (glowSprite) {
                this.visuals.toLocal(new PIXI.Point(0, 0), glowSprite, glowSprite.position);
                this.visuals.addChild(glowSprite);
            }
            else {
                console.error(this.name + "-on-glow.png");
            }
        }

        if (isMobile()) {
            if (this.hoverSFX) {
                AudioChannel.SFX.play(this.hoverSFX, 0.5, "loop");
            }
        }

        if (this.switched) {
            this.switched.TurnOn(pOptions);
        }
    }

    public TurnOff(pOptions: {animate: boolean} = {animate: true}): void {
        this.onOut?.call(this, this);

        if (this.objectType !== "easteregg") {
            this.clickSfx = "deadclick";
            // this.enabled = false;
            this.clickable = false;
        }
        this.turnedOff = true;

        if (this.objectType === LightsOutObjectType.Light) {
            const glowSprite = this.getChildByName(this.name + "-on-glow", true);
            if (glowSprite) {
                glowSprite.visible = false;
            }
        }

        if (pOptions.animate === true) {
            PubSub.publishSync("item turned off", this);
            if (this.lightsOutSFX) {
                AudioChannel.SFX.play(this.lightsOutSFX);
            }
        }

        this.UnHighlight();
        if (this.hoverSFX) {
            AudioChannel.SFX.stop(this.hoverSFX);
        }

        if (this.switched) {
            this.switched.TurnOff(pOptions);
        }
    }

    public Highlight() {
        this.outlineFilter.enabled = true;
    }

    public UnHighlight() {
        this.outlineFilter.enabled = false;
    }

    public destroy() {
        if (this.hoverSFX) {
            AudioChannel.SFX.stop(this.hoverSFX);
        }
        super.destroy();
    }
}
